document.addEventListener("DOMContentLoaded", addOneModalHandler);


const addOneModalRefs = {
  modal: document.getElementById("add--one--modal"),
  openers: document.querySelectorAll(".add-one__popup-opener"),
  closeBtn: document.querySelector(
    "#add--one--modal .add--one--modal__close"
  ),
  title: document.querySelector(
    "#add--one--modal .add--one--modal__info--title"
  ),
  raiting: document.querySelector(
    "#add--one--modal .add--one--modal__info--raiting"
  ),
  description: document.querySelector(
    "#add--one--modal .add--one--modal__info--description"
  ),
  imageList: document.querySelector(
    "#add--one--modal .add--one--modal__image--list"
  ),
  paginationImageList: document.querySelector(
    "#add--one--modal .add--one--modal__image--list__pagination"
  ),
  modalHandlersBox: document.querySelector("[is-addone-modal-handlers-box]"),
  modalColorPickerBox: document.querySelector("[is-addone-modal-colors]"),
  modalVariantPickerBox: document.querySelector("[is-addone-modal-variants]"),
  modalCheckbox: document.querySelector("[is-addone-modal-checkbox]"),
};

window.addOneModalRefs = addOneModalRefs;

window.renderAddOneGallery = function (
  productId,
  variantId,
  addOneModalRefs,
  title
) {
  const tmpl = document.querySelector(
    `.addone-media-template[data-product-id="${productId}"]`
  );
  if (!tmpl) {
    console.warn("No template found for add-one product:", productId);
    return;
  }

  const parser = new DOMParser();
  const html = parser.parseFromString(tmpl.innerHTML, "text/html");
  const block =
    html.querySelector(`.addone-media-block[data-variant-id="${variantId}"]`) ||
    html.querySelector(".addone-media-block[data-variant-id]");

  if (!block) {
    console.warn("No variant block found in template for variant:", variantId);
    return;
  }

  const imgs = block.querySelectorAll("img");
  const mediaArr = Array.from(imgs).map((img) => ({
    media_type: "image",
    src: img.getAttribute("src"),
    alt: img.getAttribute("alt") || "",
  }));

  const $imageList = $(addOneModalRefs.imageList);
  const $paginationList = $(addOneModalRefs.paginationImageList);

  $imageList.empty();
  $paginationList.empty();

  mediaArr.forEach((item) => {
    const $slideElem = $('<li class="swiper-slide"></li>');
    const $slideImg = $("<img>", {
      src: item.src,
      alt: item.alt || title,
    });
    $slideElem.append($slideImg);
    $imageList.append($slideElem);
    $paginationList.append($slideElem.clone());
  });

  if (window.modalPaginationSlider)
    window.modalPaginationSlider.destroy(true, true);
  if (window.modalSwiper) window.modalSwiper.destroy(true, true);

  window.modalPaginationSlider = new Swiper(
    "#add--one--modal__image--slider_pagination",
    {
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 7,
      allowTouchMove: true,
      navigation: {
        nextEl: ".modal--slider--next",
        prevEl: ".modal--slider--prev",
      },
    }
  );

  window.modalSwiper = new Swiper("#add--one--modal__image--slider", {
    loop: false,
    navigation: {
      nextEl: ".modal--slider--next",
      prevEl: ".modal--slider--prev",
    },
    thumbs: { swiper: window.modalPaginationSlider },
  });

  window.modalSwiper.slideTo(0, 0, false);
};

function addOneModalHandler() {
  const addOneModalRefs = {
    modal: document.getElementById("add--one--modal"),
    openers: document.querySelectorAll(".add-one__popup-opener"),
    closeBtn: document.querySelector(
      "#add--one--modal .add--one--modal__close"
    ),
    title: document.querySelector(
      "#add--one--modal .add--one--modal__info--title"
    ),
    raiting: document.querySelector(
      "#add--one--modal .add--one--modal__info--raiting"
    ),
    description: document.querySelector(
      "#add--one--modal .add--one--modal__info--description"
    ),
    imageList: document.querySelector(
      "#add--one--modal .add--one--modal__image--list"
    ),
    paginationImageList: document.querySelector(
      "#add--one--modal .add--one--modal__image--list__pagination"
    ),
    modalHandlersBox: document.querySelector("[is-addone-modal-handlers-box]"),
    modalColorPickerBox: document.querySelector("[is-addone-modal-colors]"),
    modalVariantPickerBox: document.querySelector("[is-addone-modal-variants]"),
    modalCheckbox: document.querySelector("[is-addone-modal-checkbox]"),
  };

  window.addOneModalRefs = addOneModalRefs; // make globally accessible for re-renders

  let modalSwiper;
  let modalPaginationSlider;
  let addoneCheckboxLabel = null;

  function modalCheckboxHandle() {
    const currentId = $("[is-addone-modal-checkbox]").attr("data-id");
    const mmqCode = $(`.mmqMonitorArmConfig[data-id="${currentId}"]`).attr(
      "data-mmq-code"
    );
    const mmqBlock = $(`.mmqMonitorArmConfig[data-id="${currentId}"]`).attr(
      "data-mmq-block"
    );

    $(addoneCheckbox).val(currentId).attr({
      "data-id": currentId,
      "data-mmq-block": mmqBlock,
      "data-mmq-code": mmqCode,
    });

    $(addoneCheckbox).prop("checked", !$(addoneCheckbox).prop("checked"));
    $(addoneCheckbox).trigger("change");

    console.log(
      "✅ addoneCheckbox toggled programmatically",
      $(addoneCheckbox).prop("checked")
    );

    setTimeout(closeAddOneModal, 200);
  }

  function closeAddOneModal() {
    $(".variantImage__js-addone").removeClass("active");
    toggleAddOneModal();

    addOneModalRefs.modalCheckbox.removeEventListener(
      "change",
      modalCheckboxHandle
    );

    if (modalSwiper) {
      modalSwiper.destroy();
      modalPaginationSlider.destroy();
      modalSwiper = null;
      modalPaginationSlider = null;
    }

    const tidioChat = document.getElementById("tidio-chat-iframe");
    if (tidioChat) tidioChat.style.display = "block";

    $(".video_container__popup video").each(function () {
      this.pause();
    });
  }

  function toggleAddOneModal() {
    addOneModalRefs.modal.classList.toggle("open");
    addOneModalRefs.modalHandlersBox.classList.toggle("open");
    $('.add-one-modal_handlers_outer__overlay').toggleClass('open');
    document.body.classList.toggle("modal--open");

    const tidioChat = document.getElementById("tidio-chat-iframe");
    if (tidioChat)
      tidioChat.style.display = addOneModalRefs.modal.classList.contains("open")
        ? "none"
        : "block";
  }

  function onModalOpenerClick(event) {
    const $trigger = $(event.currentTarget);
    const $addOneContainer = $trigger.closest(".product-single__add-one");

    addoneCheckboxLabel = $addOneContainer.find("[is-checkbox-label]")[0];
    addoneCheckbox = $addOneContainer.find("[is-checkbox-label] input")[0];

    addOneModalRefs.modalCheckbox.checked = addoneCheckbox.checked;
    $(addOneModalRefs.modalCheckbox)
      .off("change")
      .on("change", modalCheckboxHandle);

    const $addOneRating = $addOneContainer.find(".add-one__raiting").clone();
    const $colorPickers = $addOneContainer.find(
      ".add-one__variants .add-one__item.color .add-one__options label"
    );
    const $variantPickers = $addOneContainer.find(
      ".add-one__variants .product__swatch-container label"
    );
    const $containerInit = $trigger.closest(".product-single__add-one");
    const $doubleAddonsSwitchInit = $containerInit.find(".addone_items-product-switch"); 


    $(addOneModalRefs.modalColorPickerBox).empty();
    $(addOneModalRefs.modalVariantPickerBox).empty();

    // store the current color selection before re-render
    const prevColorCode = $addOneContainer
      .find(".add-one__item.color input[type='radio']:checked")
      .attr("data-mmq-code");

    let hasCheckedColor = false;
    const $box = $(addOneModalRefs.modalColorPickerBox);
    const colorsCount = $colorPickers.length;
    const variantsCount = $variantPickers.length;
    const doubleSwitchCount = $doubleAddonsSwitchInit.length;
    const hasManyColors = colorsCount > 5 && (variantsCount > 1 || doubleSwitchCount >= 1);
    const isRizerAddon = $addOneContainer.hasClass("is-monitor-rizer-addon");

    if (isRizerAddon) {
      $box.append('<div class="modal--color__arrow modal--color__arrow--prev disableArrow"><img loading="lazy" src="https://sfycdn.speedsize.com/df738009-02a8-488b-bc12-341d7f8bc071/cdn.shopify.com/s/files/1/0511/8961/2733/files/Vector_83.png?v=1763462513"></div>');
    }
    const $target = $('<div class="modal--color__wrapper"></div>').appendTo($box);
    if (isRizerAddon) {
      $box.append('<div class="modal--color__arrow modal--color__arrow--next disableArrow"><img loading="lazy" src="https://sfycdn.speedsize.com/df738009-02a8-488b-bc12-341d7f8bc071/cdn.shopify.com/s/files/1/0511/8961/2733/files/Vector_82.png?v=1763462513"></div>');
    }

    $colorPickers.each(function () {
      const $label = $(this);
      const $input = $label.prev();

      const $colorModalLabel = $('<label class="modal--color__label"></label>');
      if ($input.is(":checked")) {
        $colorModalLabel.addClass("activelabel");
        hasCheckedColor = true;
      }
      if ($label.hasClass("addone-color-label-out"))
        $colorModalLabel.addClass("addone-color-label-out");

      const $colorModalInput = $("<input>", {
        type: "radio",
        name: "modal--color",
        disabled: $label.hasClass("addone-color-label-out"),
        checked: $input.is(":checked"),
      });

      const mmq = ($input.attr("data-mmq-code") || "").trim();
      if (mmq.length > 0) {
        if (prevColorCode && $input.attr("data-mmq-code") === prevColorCode) {
          $colorModalInput.prop("checked", true);
          $colorModalLabel.addClass("activelabel");
          hasCheckedColor = true;
        }
      }

      const $colorBallSpan = $label.find("span.swatch-color-ball").clone();
      const $tooltipSpan = $label
        .find("span.product__variant-label-text_tooltip")
        .clone();

      $colorModalLabel.append($colorModalInput, $colorBallSpan, $tooltipSpan);
      $target.append($colorModalLabel);
      // $(addOneModalRefs.modalColorPickerBox).append($colorModalLabel);
    });

    if (!hasCheckedColor) {
      const $firstInput = $(addOneModalRefs.modalColorPickerBox)
        .find(".modal--color__label:not(.addone-color-label-out)")
        .first();

      if ($firstInput.length) {
        $firstInput.addClass("activelabel");
        $firstInput.find("input[type='radio']").prop("checked", true);
      }
    }

    const $outer = $box.closest(".add--one--modal__handler--box__outer");
    $outer.toggleClass("is-rizer-modal", isRizerAddon);
    if (isRizerAddon) {
      updateModelSliderArrows($box);
      $outer.toggleClass("has-many-colors", colorsCount > 6);
    } else {
      $outer.removeClass("has-many-colors");
    }



    $variantPickers.each(function () {
      const $label = $(this);
      const $input = $label.prev();
      const currentValue = $label.data("value-handle");

      const $variantModalLabel = $("<label></label>")
        .addClass("modal--variant__label")
        .attr("data-value-handle", currentValue)
        .html($label.html());

      if ($input.is(":checked")) $variantModalLabel.addClass("activelabel");
      if ($label.hasClass("addone-switcher-label-out"))
        $variantModalLabel.addClass("addone-switcher-label-out");

      const $variantModalInput = $("<input>", {
        type: "radio",
        name: "modal--variant",
        disabled: $label.hasClass("addone-switcher-label-out"),
      });

      const $svg = $label.find("svg").clone();
      $variantModalLabel.append($variantModalInput, $svg);

      $variantModalInput.on("change", function () {
        $(".product-single__add-ons").attr("data-from-popup", "1");
        $label.trigger("click");
        setTimeout(
          () => $(".product-single__add-ons").attr("data-from-popup", "0"),
          1000
        );
      });

      $(addOneModalRefs.modalVariantPickerBox).append($variantModalLabel);
    });

    const { description, title, url, id } = $addOneContainer.data();
    const productId = $addOneContainer.data("id");
    const currentProductId = $addOneContainer.find('.add-one__popup-opener').attr('data-product-id');
    const variantId = $addOneContainer
      .find(".addOneMainInput__js")
      .attr("data-id");

    const buttonText = $(".pdp_variables_for_popups").data("more");
    if ($trigger.closest(".product-single__add-one").find('.addone_item-switch[data="second"]').hasClass('active')){
      var secondDescription = $trigger.closest(".product-single__add-one").attr('data-description-second');
      var secondTitle = $trigger.closest(".product-single__add-one").attr('data-title-second');
      var secondRating = $trigger.closest(".product-single__add-one").attr('data-rating-second');

      $(addOneModalRefs.title).html(secondTitle);
      $(addOneModalRefs.description).html(
        secondDescription + ` <a href="${url}">${buttonText}</a>`
      );
      $(addOneModalRefs.raiting).empty().append(secondRating);
    }
    else{
      $(addOneModalRefs.title).html(title);
      $(addOneModalRefs.description).html(
        `${description} <a href="${url}">${buttonText}</a>`
      );
      $(addOneModalRefs.raiting).empty().append($addOneRating);
    }

    const $container = $trigger.closest(".product-single__add-one");
    const $doubleAddonsSwitch = $container.find('.addone_items-product-switch');
    const $doubleAddonsSwitchHtml = $container.find('.addone_items-product-switch__outer').html();

    if ($doubleAddonsSwitch.length) {

      $('.add--one--modal__handler--box[is-addone-modal-variants]').html($doubleAddonsSwitchHtml);
    }

    $(addOneModalRefs.imageList).empty();
    $(addOneModalRefs.paginationImageList).empty();

    window.renderAddOneGallery(productId, variantId, addOneModalRefs, title);

    window.calculateTabs(currentProductId, variantId);

    $(".add--one--modal__handlers")
      .off("click")
      .on("click", function () {
        if (window.modalSwiper) window.modalSwiper.slideTo(0, 0, false);
        $(".add--one--modal").scrollTop(0);
      });

    toggleAddOneModal();
    requestAnimationFrame(() => {
      scrollModalColorsToActive($box);
      updateModelSliderArrows($box);
    });
  }

  addOneModalRefs.modal.addEventListener("click", (event) => {
    if (event.target === event.currentTarget) {
      closeAddOneModal();
      window.removePreloads();
    }
  });

  addOneModalRefs.closeBtn.addEventListener("click", closeAddOneModal);

  addOneModalRefs.openers.forEach((opener) => {
    opener.addEventListener("click", function (event) {
      onModalOpenerClick(event);

      const currentId = $(this).attr("data-product-id");
      $(".add--one--modal__content").attr("data-product-id", currentId);

      setTimeout(() => {
        $(".product-single__add-ons__wrap").removeClass("preload");
        $(".add--one--modal__handler--box").trigger("click");
      }, 200);
    });
  });
}

function updateSliderArrows(listItem) {
  var sliderContainer = listItem.find(".add-one__item");
  var arrowPrev = listItem.find(".add-one__item-slider-prev");
  var arrowNext = listItem.find(".add-one__item-slider-next");

  var scrollLeft = sliderContainer.scrollLeft();
  var maxScroll =
    sliderContainer[0].scrollWidth - sliderContainer[0].clientWidth;

  if (scrollLeft <= 2) {
    arrowPrev.addClass("disableArrow");
  } else {
    arrowPrev.removeClass("disableArrow");
  }

  if (scrollLeft >= maxScroll - 2) {
    arrowNext.addClass("disableArrow");
  } else {
    arrowNext.removeClass("disableArrow");
  }
}

$(document).ready(function () {
  $(".product-single__add-one").each(function () {
    updateSliderArrows($(this));
  });

  // Monitor-holder tooltip: toggle on click for mobile (where :hover is unreliable)
  if (window.innerWidth < 768) {
    $(document).on("click", ".pdp_monitor-holder--tooltip", function (e) {
      e.stopPropagation();
      $(this).closest(".pdp_monitor-holder--tooltip-wrap").toggleClass("active");
    });
    $(document).on("click", function () {
      $(".pdp_monitor-holder--tooltip-wrap.active").removeClass("active");
    });
  }

  $(document).on(
    "click",
    ".add-one__item-slider-prev, .add-one__item-slider-next",
    function (event) {
      event.stopPropagation();
      
      var arrow = $(this);
  
      var sliderContainer = arrow
        .closest('.add-one__item-variants-slider-box')
        .find('.add-one__item');
  
      if (!sliderContainer.length) return;
  
      var scrollDistance = 100;
      var currentScroll = sliderContainer.scrollLeft();
      var containerRect = sliderContainer[0].getBoundingClientRect();

      // Collect the absolute scroll-content left edge of each swatch item
      var snapPositions = [];
      sliderContainer.find('fieldset > div').each(function () {
        var itemLeft = this.getBoundingClientRect().left - containerRect.left + currentScroll;
        snapPositions.push(Math.round(itemLeft));
      });

      var targetScroll;

      if (arrow.hasClass("add-one__item-slider-prev")) {
        var proposed = currentScroll - scrollDistance;
        targetScroll = 0;
        for (var i = snapPositions.length - 1; i >= 0; i--) {
          if (snapPositions[i] <= proposed) {
            targetScroll = snapPositions[i];
            break;
          }
        }
      } else {
        var proposed = currentScroll + scrollDistance;
        var maxScroll = sliderContainer[0].scrollWidth - sliderContainer[0].clientWidth;
        targetScroll = maxScroll;
        for (var i = 0; i < snapPositions.length; i++) {
          if (snapPositions[i] >= proposed) {
            targetScroll = snapPositions[i];
            break;
          }
        }
      }

      sliderContainer.animate({ scrollLeft: targetScroll }, 200);

      setTimeout(function () {
        updateSliderArrows(arrow.closest(".product-single__add-one"));
      }, 250);
    }
  );

  $(".product-single__add-one .add-one__item.color").on("scroll", function () {
    var listItem = $(this).closest(".product-single__add-one");
    updateSliderArrows(listItem);
  });
});



function scrollModalColorsToActive($box) {
  const $slider = $box.find(".modal--color__wrapper");
  if (!$slider.length) return;

  const $active =
    $slider.find(".modal--color__label.activelabel").first().length
      ? $slider.find(".modal--color__label.activelabel").first()
      : $slider.find(".modal--color__label input:checked").closest(".modal--color__label").first();

  if (!$active.length) return;
  const sliderEl = $slider[0];
  const activeEl = $active[0];
  const target =
    activeEl.offsetLeft - (sliderEl.clientWidth / 2) + (activeEl.offsetWidth / 2);
  const max = sliderEl.scrollWidth - sliderEl.clientWidth;
  const clamped = Math.max(0, Math.min(target, max));
  $slider.stop(true).animate({ scrollLeft: clamped }, 0); 
}
 

function updateModelSliderArrows($box) {
  const $slider = $box.find(".modal--color__wrapper");
  const $prev = $box.find(".modal--color__arrow--prev");
  const $next = $box.find(".modal--color__arrow--next");

  if (!$slider.length) return;

  const el = $slider[0];
  const maxScroll = Math.max(0, el.scrollWidth - el.clientWidth);
  const scrollLeft = el.scrollLeft;
  const EDGE = 2;

  if (maxScroll <= EDGE) {
    $prev.addClass("disableArrow");
    $next.addClass("disableArrow");
    return;
  }

  $prev.toggleClass("disableArrow", scrollLeft <= EDGE);
  $next.toggleClass("disableArrow", scrollLeft >= maxScroll - EDGE);
}


$(document).ready(function () {
  $(document).on("click", ".modal--color__arrow", function (event) {
  event.preventDefault();
  event.stopPropagation();

  const $arrow = $(this);
  const $box = $arrow.closest("[is-addone-modal-colors]");
  const $slider = $box.find(".modal--color__wrapper");

  if (!$slider.length) return;

  const step = 120;
  const current = $slider.scrollLeft();
  const isPrev = $arrow.hasClass("modal--color__arrow--prev");

  $slider.stop(true).animate({ scrollLeft: current + (isPrev ? -step : step) }, 200);

  setTimeout(() => updateModelSliderArrows($box), 220);
});

  $(document).on("scroll", "[is-addone-modal-colors] .modal--color__wrapper", function () {
    const $box = $(this).closest("[is-addone-modal-colors]");
    updateModelSliderArrows($box);
  });

});
